import { SpecialistChatData } from '~/types/Timeline';
import { Member } from '~/types/User';
import { MedicalUser } from '~/types/Project/medicalTeam';
import { QuestionTemplate } from '~/types/QuestionTemplate';
import { TodoType, TodoStatus } from '~/components/settings/Todo';

export interface Todo {
  id: string;

  projectId: string;

  userId: string;

  typeId: string;

  moduleId: string;

  /** どのやることリストかを識別 */
  todoType: TodoType;

  /** やることリストの状態 */
  status: TodoStatus;

  /** チャットのタイトル */
  title?: string;

  /** 請求の根拠 */
  reason?: string;

  /** その他の画像 */
  image?: string;

  timestamp: {
    createdBy: string | null;
    createdAt: string;
    completedAt: string;
    deadlineAt?: string | null;
    reservationAt?: string | null;
  }

  creater: Member;

  isTest: boolean;

  date: string;
  typeLabel: string;
  statusLabel: string;
  location: string | null;

  scheduledAt?: string;
  endAt?: string;
  owner?: any;

}

export interface TodoDeadline extends Todo {
  /** オンライン医療相談のときのみ */
  scheduledAt: string;

  /** オンライン医療相談のときのみ */
  endAt: string;

  /** オンライン医療相談主催者（期限ありのやることリストのみ） */
  owner: Member;

  /** オンライン医療相談 zoomパラメータ */
  zoom: {
    url: string
  }

  isTest: boolean;
}

export interface TodoNoDeadline extends Todo {
  /** 問診テンプレートデータ |｜ チャット医療相談データ */
  data?: QuestionTemplate | SpecialistChatData;
}

export enum ProjectType {
  Integration = 'integration',
  HealthCheck = 'healthCheck',
  MentalHealth = 'mentalHealth',
}

export enum LaneType {
  Chat = 'chat',
  Inquiry = 'inquiry',
  Reservation = 'reservation',
  Other = 'other',
}

export enum StickyType {
  SpecialistChat = 'specialistChat',
  Chat = 'chat', // 'chat' | // chatのサブタイプ
  Inquiry = 'inquiry', // 'inquiry' | // inquiryのサブタイプ A
  Reservation = 'reservation', // 'reservation' | 'reservationComplete' | // reservationのサブタイプ reservation: C, D, F reservationComplete: E
  ReservationComplete = 'reservationComplete',
  Notification = 'notification', // 'notification' | 'article'; // otherのサブタイプ notification: G, H, I article: J
  Article = 'article',
}

export const laneTypes = [
  LaneType.Chat,
  LaneType.Inquiry,
  LaneType.Reservation,
  LaneType.Other,
];

interface MedicalUserWithPosition extends MedicalUser {
  medicalProfile: {
    position: string;
  };
}

/**
 * 個別の付箋カード情報
 * projectType: アイコンの指定
 * type: レーンの指定
 * subType: 付箋カードUIの種類の指定
 * date: 日付
 * title: タイトル
 * custom: 個別の情報
 */
export interface ToDoListItem {
  id: number;
  projectId: string;
  projectType: ProjectType;
  laneType: LaneType;
  stickyType: StickyType;
  date: string;
  title: string;
  content: string;
  custom: {
    imageUrl?: string; // subType == articleの時
    user?: MedicalUserWithPosition; // subType == chatの時 MedicalUserかも
    reservationDate?: string; // subType == reservationCompleteの時
  }
}

export interface ToDoListResponse {
  todoList: ToDoListItem[]
  page: number;
  totalCount: number;
}

export interface TodoListRequest {
  limit: number;
  page?: number; // default 0
  laneType: LaneType
}
